<template>
  <v-col>
    <v-card elevation="3" outlined class="px-4 py-4 partbg">
      <div
        class="mx-3 d-flex flex-column justify-center align-content-center text-center hide-after-responsive"
      >
        <div class="">
          <v-avatar size="40">
            <v-img :src="p.image" @error="handleImageError(p)"></v-img>
          </v-avatar>
        </div>
        <div class="">{{ p.fName }} {{ p.lName }}</div>
        <div class="livelaps-id">
          {{ $t("memberRegistration.step4.content.participant.livelaps_id") }}:
          {{ p.userId }}
        </div>
      </div>

      <v-data-table
        :headers="headers"
        :items="selections"
        class="elevation-1"
        :no-data-text="$t('membership.no_data_available')"
        :headerProps="{
          'sort-by-text': $t('dataTable.sortByText')
        }"
        :footer-props="{ 
          'items-per-page-text': $t('membership.items_per_page_text'),
          'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
        }"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>
              <table>
                <tr>
                  <td>
                    <v-avatar size="40">
                      <v-img
                        :src="p.image"
                        @error="handleImageError(p)"
                      ></v-img>
                    </v-avatar>
                  </td>
                  <td>
                    <div>{{ p.fName }} {{ p.lName }}</div>
                    <div class="livelaps-id">
                      {{
                        $t(
                          "memberRegistration.step4.content.participant.livelaps_id"
                        )
                      }}: {{ p.userId }}
                    </div>
                  </td>
                </tr>
              </table>
            </v-toolbar-title>
            <v-spacer class="d-none d-md-flex"></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="!showAddClassBtn"
                  color="primary"
                  dark
                  class="mb-2 center-on-responsive btn-class"
                  v-bind="attrs"
                  v-on="on"
                  @click="getMemberClasses"
                >
                  {{
                    $t(
                      "memberRegistration.step4.content.participant.add_class"
                    )
                  }}
                </v-btn>
              </template>
              <v-card :loading="editedItem.loading">
                <v-card-title>
                  <span class="text-h5">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-alert
                      v-if="noClassMessage"
                      type="warning"
                      border="left"
                      colored-border
                      class="mb-4"
                    >
                      {{ noClassMessage }}
                    </v-alert>
                    <div v-if="noClassReason === 'no_birthday'" class="mb-4">
                      <BDatePicker :part="dobPart" @send="onDobEntered" />
                    </div>
                    <v-row>
                      <v-col lg="12" md="12" cols="12" v-if="!noClassMessage">
                        <v-autocomplete
                          outlined
                          :label="
                            $t(
                              'memberRegistration.step4.content.participant.racing_type'
                            )
                          "
                          deletable-chips
                          small-chips
                          v-model="editedItem.group"
                          :items="groupsAvailable"
                          item-text="name"
                          item-value="id"
                          :return-object="true"
                          @change="onGroupChange"
                        ></v-autocomplete>
                      </v-col>
                      <v-col lg="12" md="12" cols="12" v-if="editedItem.group">
                        <v-autocomplete
                          outlined
                          :label="$t('memberRegistration.step4.content.participant.class')"
                          :hint="formattedPreviousClassAndRaceNumber.classLbl"
                          persistent-hint
                          deletable-chips
                          small-chips
                          v-model="editedItem.class"
                          :items="filteredClasses"
                          item-text="nameWithFee"
                          item-value="id"
                          :return-object="true"
                        ></v-autocomplete>
                      </v-col>
                      <v-col
                        lg="12"
                        md="12"
                        cols="12"
                        v-if="availableRaceNumbers.length > 0"
                      >
                        <v-autocomplete
                          outlined
                          :label="
                            $t(
                              'memberRegistration.step4.content.participant.race_number'
                            )
                          "
                          :hint="formattedPreviousClassAndRaceNumber.raceLbl"
                          persistent-hint
                          deletable-chips
                          small-chips
                          v-model="editedItem.raceNumber"
                          :items="availableRaceNumbers"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    {{ $t("common.cancel") }}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="save"
                    :disabled="isSaveDisabled"
                  >
                    {{ $t("common.save") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5">{{
                  $t("common.sure_delete")
                }}</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete">{{
                    $t("common.cancel")
                  }}</v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="deleteItemConfirm"
                    >{{ $t("common.ok") }}</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-col>
</template>

<script>
import {
  VDataTable,
  VCol,
  VRow,
  VBtn,
  VIcon,
  VSpacer,
  VCardActions,
  VCardTitle,
  VCard,
  VDialog,
  VContainer,
  VCardText,
  VToolbarTitle,
  VImg,
  VAvatar,
  VToolbar,
  VAutocomplete,
  VAlert,
} from "vuetify/lib";

import APIService from "@/services/APIService";
import ProfileService from "@/services/ProfileService";
import BDatePicker from "@/components/profile/BDatePicker.vue";
import { mapState } from "vuex";

export default {
  components: {
    VDataTable,
    VCol,
    VRow,
    VBtn,
    VIcon,
    VSpacer,
    VCardActions,
    VCardTitle,
    VCard,
    VDialog,
    VContainer,
    VCardText,
    VToolbarTitle,
    VImg,
    VAvatar,
    VToolbar,
    VAutocomplete,
    VAlert,
    BDatePicker,
  },
  props: {
    p: { type: Object, required: true },
    participants: Array,
    selectedParticipants: Array,
    membershipTypeId: Number,
    organizationId: Number,
  },
  data() {
    return {
      dialog: false,
      dialogDelete: false,
      selections: [],
      editedIndex: -1,
      editedItem: {
        group: null,
        class: null,
        className: null,
        raceNumber: null,
        userId: null,
        organizationRaceClassId: null,
        loading: false,
      },
      defaultItem: {
        group: null,
        class: null,
        className: null,
        raceNumber: null,
        userId: null,
        organizationRaceClassId: null,
        loading: false,
      },
      tempItem: {
        group: null,
        class: null,
        className: null,
        raceNumber: null,
        userId: null,
        organizationRaceClassId: null,
        loading: false,
      },
      participantImagePlaceholder:
        "/participant/img/partPlaceholder.a4cd1320.jpg",
      groupedClasses: [],
      groupedClassesKeys: [],
      availableRaceNumbers: [],
      skipRaceNumbers: false,
      saveIsEneabled: false,
      pastInfos: [],
      activePastInfo: null,
      organizationClasses: [],
      previousRaceClass: '',
      previousRaceNumber: '',
      isEditing: false,
      noClassReason: null,
      noClassAge: null,
      noClassAgeCalculation: null,
      noClassOrganizationName: null,
      noClassContactEmail: null,
      noClassAgeYear: null,
      dobPart: {
        id: this.p.userId,
        date: this.p.birthday || null,
        menu: false,
      },
    };
  },

  computed: {
    headers() {
      return [
      {
        text: this.$t('memberRegistration.step4.content.participant.racing_type'),
        align: "start",
        value: "group.name",
      },
      { 
        text: this.$t('memberRegistration.step4.content.participant.class'), 
        value: "className" },
      { 
        text: this.$t('memberRegistration.step4.content.participant.race_number'),
        value: "raceNumber" },
      { 
        text: this.$t('emergencyContact.actions'), 
        value: "actions", 
        sortable: false 
      },
    ]
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("memberRegistration.step4.content.participant.add_class")
        : this.$t("memberRegistration.step4.content.participant.edit_class");
    },
    hiddenGroups() {
      return this.selections
        .filter((obj) => obj.class.isMultiReg == 0)
        .map((obj) => obj.group);
    },
    groupsAvailable() {
      if(this.isEditing) return this.organizationClasses;
      
      return this.organizationClasses.filter(
        (item) => !this.hiddenGroups.some((hiddenItem) => hiddenItem.id === item.id)
      );
    },
    showAddClassBtn() {
      return (
        this.groupsAvailable.length > 0 || this.groupedClassesKeys.length == 0
      );
    },
    selectedCurrentGroupClasses() {
      return this.selections
        .filter((obj) => obj.group.id == this.editedItem.group.id)
        .map((obj) => obj.class.id);
    },
    filteredClasses() {
      if(!this.editedItem.group) return [];
      let groupedClasses = [...this.groupedClasses[this.editedItem.group.id]].filter(
        (obj) =>
          !this.selectedCurrentGroupClasses.length ||
          !this.selectedCurrentGroupClasses.includes(obj.id)
      );
      
      if (
        this.tempItem.class &&
        !groupedClasses.includes(this.tempItem.class)
      ) {
        groupedClasses.unshift({ divider: true });
        groupedClasses.unshift(this.tempItem.class);
      }

      return groupedClasses.map((obj) => {
        let label = obj.name;

        if(obj.addedFee == 0) return { ...obj, nameWithFee: label };
        
        const prefix = obj.addedFee > 0 ? '+' : '-';
        label += ` (${prefix}${obj.addedFee} $)`;

        return { ...obj, nameWithFee: label };
      });
    },
    ...mapState({
      urlDomain: (state) => state.env.get("VUE_APP_ROOT"),
      userStore: (state) => state.session.user,
    }),
    authUserId() {
      return this.userStore && this.userStore.id ? this.userStore.id : 0;
    },
    noClassMessage() {
      if (!this.noClassReason) return null;

      const name = `${this.p.fName} ${this.p.lName}`;
      const orgName = this.noClassOrganizationName || '';
      const email = this.noClassContactEmail || '';
      const contact = email ? `${orgName} (${email})` : orgName;
      const params = {
        name,
        age: this.noClassAge,
        year: this.noClassAgeYear,
        org: orgName,
        contact,
      };
      const base = 'memberRegistration.step4.content.participant.';

      switch (this.noClassReason) {
        case 'age':
          return this.$t(
            base + (Number(this.noClassAgeCalculation) === 1 ? 'no_class_jan1' : 'no_class_birthday'),
            params
          );
        case 'no_birthday':
          return this.$t(base + 'no_class_no_birthday', params);
        case 'priority':
          return this.$t(base + 'no_class_priority', params);
        case 'membership_type':
          return this.$t(base + 'no_class_membership_type', params);
        case 'already_registered':
          return this.$t(base + 'no_class_already_registered', params);
        case 'no_classes_configured':
          return this.$t(base + 'no_class_no_classes_configured', params);
        case 'unknown':
          return this.$t(base + 'no_class_unknown', { name });
        default:
          return this.$t(base + 'no_class_other', params);
      }
    },
    rditedGoup() {
      return this.editedItem.group;
    },
    editedClass() {
      return this.editedItem.class;
    },
    editedNumber() {
      return this.editedItem.raceNumber;
    },
    selectedRClassesAndRNumbers() {
      let response = [];
      for (var i = 0; i < this.selections.length; i++) {
        response.push({
          raceNumber: this.selections[i].raceNumber,
          raceClassId: this.selections[i].class.id,
          userId: this.p.userId,
          organizationRaceClassId: this.selections[i].organizationRaceClassId,
        });
      }

      return response;
    },
    lastSelection()
    {
      let response = {
        className: null,
        raceNumber: null,
      };

      if (this.selections.length == 0) return response;

      const lastSelection = this.selections[this.selections.length - 1];

      response.clasName = lastSelection.className;
      response.raceNumber = lastSelection.raceNumber;

      return response;
    },
    formattedPreviousClassAndRaceNumber() {
      return {
        classLbl: !this.previousRaceClass
          ? ""
          : `${this.$t(
              "memberRegistration.step4.content.participant.previous_class"
            )}: ${this.previousRaceClass}`,
        raceLbl: !this.previousRaceNumber
          ? ""
          : `${this.$t(
              "memberRegistration.step4.content.participant.previous_number"
            )}: ${this.previousRaceNumber}`,
      };
    },
    isSaveDisabled() {
      const hasGroupSelected = !!this.editedItem.group;
      const hasClassSelected = !!this.editedItem.class;
      const hasAvailableRaceNumbers = this.availableRaceNumbers.length > 0;
      const hasRaceNumberSelected = !!this.editedItem.raceNumber;

      if (this.noClassReason) return true;
      if (this.editedItem.loading) return true;
      if (!hasGroupSelected || !hasClassSelected) return true;
      if (hasAvailableRaceNumbers && !hasRaceNumberSelected) return true;

      return false;
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    rditedGoup(val)
    {
      this.activePastInfo = null;
      
      if (!val) {
        this.editedItem.class = null;
        this.editedItem.raceNumber = null;
        this.editedItem.class = null;
        return;
      }
      const organizationClassId = val.id

      this.activePastInfo = this.pastInfos.find(obj => obj.organizationClassesId === organizationClassId);

      if(this.editedIndex == -1 && this.activePastInfo && this.groupedClasses[organizationClassId].filter(obj => obj.id == this.activePastInfo.classId).length == 1)
      {
        const classId = this.groupedClasses[organizationClassId].filter(obj => obj.id == this.activePastInfo.classId)[0].id;
        const [autoSelectedClass] = this.filteredClasses.filter(obj => obj.id == classId);
        this.editedItem.class = autoSelectedClass;
      }
      else if (this.groupedClasses[organizationClassId] && this.groupedClasses[organizationClassId].length == 1)
      {
        /**
         * if we only have one class, the class will be auto selected
         */
        const classId = this.groupedClasses[organizationClassId][0].id;
        const [autoSelectedClass] = this.filteredClasses.filter(obj => obj.id == classId);
        this.editedItem.class = autoSelectedClass;
      }

    },
    editedClass(val)
    {
      this.availableRaceNumbers = [];
      this.skipRaceNumbers = false;

      if(this.editedItem.editedIndex == -1)
      {
        this.editedItem.raceNumber = null;
      }
      
      if (!val)
      {
        this.saveIsEneabled = false;
        this.editedItem.className = null;
        return;
      }

      this.getAvailableRaceNumbers();
      this.editedItem.className = val.nameWithFee;
    },
    editedNumber(val) {
      if (!val) {
        if (this.availableRaceNumbers.length) {
          this.saveIsEneabled = false;
        }
        return;
      }

      this.saveIsEneabled = true;
    },
    availableRaceNumbers(val) {
      if (!val || !val.length) return;

      if (this.availableRaceNumbers.length == 1)
        this.editedItem.raceNumber = this.availableRaceNumbers[0];
    },
    'p.userId'(newId) {
      // Re-sync dobPart when this component instance is reused for a different
      // participant (Vue may reuse instances across v-for keys).
      this.dobPart = {
        id: newId,
        date: this.p.birthday || null,
        menu: false,
      };
      this.resetNoClassState();
    },
    'p.birthday'(newBirthday) {
      // Keep the picker's displayed date aligned with the participant's
      // birthday when it is updated externally (e.g. by setParticipantsAction).
      this.dobPart.date = newBirthday || null;
    },
    selections(val) {
      // add the selections to the current participant
      // this is added to the participants array because the participant
      // is comming from the selectedParticipants wich is a computed property
      this.participants.filter(
        (obj) => obj.userId == this.p.userId
      )[0].selections = val;
      this.$emit("validateNextStep");
    },
  },
  methods: {
    getAllSelectedClassesAndNumbers() {
      var data = [];
      var participants = this.selectedParticipants.filter(
        (p) => p.selections && p.selections.length > 0
      );

      for (var p = 0; p < participants.length; p++) {
        for (var s = 0; s < participants[p].selections.length; s++) {
          data.push({
            userId: participants[p].userId,
            class: participants[p].selections[s].class.id,
            raceNumber: participants[p].selections[s].raceNumber,
            group: participants[p].selections[s].organizationRaceClassId,
          });
        }
      }

      return data;
    },
    initialize() {
      this.selections = [];
    },

    editItem(item) {
      this.isEditing = true;
      this.editedIndex = this.selections.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.tempItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.selections.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.tempItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.selections.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.tempItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.resetNoClassState();
      });
    },

    resetNoClassState() {
      this.noClassReason = null;
      this.noClassAge = null;
      this.noClassAgeCalculation = null;
      this.noClassOrganizationName = null;
      this.noClassContactEmail = null;
      this.noClassAgeYear = null;
    },

    async onDobEntered(userId, value /*, type */) {
      if (!value) return;
      if (this.editedItem.loading) return; // guard against rapid double-picks
      this.editedItem.loading = true;
      try {
        const resp = await ProfileService.updateField({
          userId,
          field: 'birthday',
          value,
          authUserId: this.authUserId,
        });
        if (resp && resp.data && resp.data.success === 1) {
          // Refresh the Vuex participants store; the parent re-renders this
          // component with an updated `p` prop and the p.birthday watcher
          // syncs the picker. Then re-run eligibility against the new DOB.
          await this.$store.dispatch('setParticipantsAction');
          await this.getMemberClasses();
          return;
        }
        this.noClassReason = 'unknown';
      } catch (e) {
        this.noClassReason = 'unknown';
      }
      this.editedItem.loading = false;
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      
      this.editedItem.userId = this.p.userId;
      this.editedItem.organizationRaceClassId = this.editedItem.class.organizationClassesId;

      if (this.editedIndex > -1)
      {
        Object.assign(this.selections[this.editedIndex], this.editedItem);
      } else {
        this.selections.push(this.editedItem);
      }

      this.close();
    },
    handleImageError(participant) {
      // If the image fails to load, replace the source with the participant's placeholder image
      participant.image = this.participantImagePlaceholder;
    },
    onGroupChange(){
      this.saveIsEneabled = false;
      // this.filteredClasses = [];
      this.editedItem.class = null;
      
      if(this.pastInfos.length > 0){
        let pastInfo = this.pastInfos.filter(obj => obj.organizationClassesId == this.editedItem.group.id);
        this.previousRaceClass = null;
        this.previousRaceNumber = null;
        if(pastInfo.length > 0){
          this.previousRaceClass = pastInfo[0].name;
          this.previousRaceNumber = pastInfo[0].number;
          const [autoSelectedClass] = this.filteredClasses.filter(obj => obj.nameWithFee  == pastInfo[0].name);
          this.editedItem.class = autoSelectedClass;
        }
      }
    },
    async getMemberClasses() {
      this.resetNoClassState();
      this.editedItem.loading = true;
      const data = {
        userId: this.p.userId,
        membershipTypeId: this.membershipTypeId,
        organizationId: this.organizationId,
        membershipEventId: this.p.membershipEventId || null,
      };

      await APIService.fetch({
        method: "post",
        data,
        path: `${this.urlDomain}/laravel/public/api/v1/participant/membership/member-registration/classes`,
      }).then((resp) => {
        if (resp.data.success) {
          const msg = resp.data.message || {};
          let classes = msg.classes || [];
          this.pastInfos = msg.pastInfos || [];
          const apiReturnedClasses = classes.length > 0;

          if(this.pastInfos.length > 0){
            // Keep backwards compatibility when stillValid is not present.
            const activePastInfos = this.pastInfos.filter(pastInfo => pastInfo?.stillValid !== false);
            classes = classes.filter(currentClass => {
              return !activePastInfos.some(pastInfo => {
                if (!pastInfo) return false;
                const isMatchingOrganizationClass = currentClass.organizationClassesId === pastInfo.organizationClassesId;
                const isNotMultipleRegistrationAllowed = currentClass.isMultiReg === 0;
                if (pastInfo.stillValid && currentClass.id === pastInfo.classId) {
                  return true;
                }
                if (isMatchingOrganizationClass && isNotMultipleRegistrationAllowed) {
                  return true;
                }
                return false;
              });
            });
          }

          // Group the array by "ocname"
          this.organizationClasses = [];
          this.groupedClasses = classes.reduce((accumulator, raceClass) => {
            const groupId = raceClass.organizationClassesId;
            const groupName = raceClass.ocname;

            if (this.organizationClasses.filter(obj => obj.id == groupId).length === 0)
            {
              this.organizationClasses.push({ id: groupId, name: groupName });
            }

            if (!accumulator[groupId]) {
              accumulator[groupId] = [];
            }

            /**
             * If the addedFee incomming from the DB is NULL,
             * its value its force to 0
             */
            raceClass.addedFee = raceClass.addedFee || 0;

            accumulator[groupId].push(raceClass);

            return accumulator;
          }, {});

          this.groupedClassesKeys = Object.keys(this.groupedClasses);

          this.noClassAge = msg.age;
          this.noClassAgeCalculation = msg.ageCalculation;
          this.noClassOrganizationName = msg.organizationName;
          this.noClassContactEmail = msg.classContactEmail;
          this.noClassAgeYear = msg.ageYear;

          if (this.organizationClasses.length === 0) {
            // If backend returned classes but the post-filter stripped them,
            // the real reason is already_registered.
            this.noClassReason = apiReturnedClasses ? 'already_registered' : (msg.noClassReason || 'other');
          } else {
            this.noClassReason = null;
          }

          if (this.groupsAvailable.length == 1)
            this.editedItem.group = this.groupsAvailable[0];

          this.editedItem.loading = false;
          this.isEditing = false;
        } else {
          // API responded but signalled failure — leave noClass* fields null
          // and surface a generic "could not load" message.
          this.noClassReason = 'unknown';
          this.editedItem.loading = false;
        }
      }).catch(() => {
        this.noClassReason = 'unknown';
        this.editedItem.loading = false;
      });
    },
    async getAvailableRaceNumbers() {
      this.editedItem.loading = true;

      const data = {
        userId: this.p.userId,
        membershipTypeId: this.membershipTypeId,
        organizationId: this.organizationId,
        classId: this.editedItem.class.id,
        membershipEventId: this.p.membershipEventId || null,
        selectedRClassesAndRNumbers: this.isEditing ? [] : this.selectedRClassesAndRNumbers, //we dont need this when we are editing
      };

      await APIService.fetch({
        method: "post",
        data,
        path: `${this.urlDomain}/laravel/public/api/v1/participant/membership/member-registration/available-race-numbers`,
      }).then((resp) => {
        if (resp.data.success) {
          const message = resp.data.message;
          this.skipRaceNumbers = message.skipRaceNumbers;
          this.editedItem.loading = false;

          if (this.skipRaceNumbers) {
            this.availableRaceNumbers = [];
            this.saveIsEneabled = true;
            return;
          }

          /**
           * get other participants selected numbers
           */
          var otherParticipantsSelectedNumbers = [
            ...new Set(
              this.getAllSelectedClassesAndNumbers()
                .filter(
                  (obj) =>
                    obj.userId != this.p.userId &&
                    obj.group === this.editedItem.class.organizationClassesId
                )
                .map((obj) => obj.raceNumber)
            ),
          ];

          //exclude other participants selected numbers from the number available
          this.availableRaceNumbers = message.availableRaceNumbers.filter(
            (element) => !otherParticipantsSelectedNumbers.includes(element)
          );

         if(this.editedIndex == -1 &&
            this.activePastInfo &&
            this.editedItem.group.id == this.activePastInfo.organizationClassesId &&
            this.editedItem.class.id == this.activePastInfo.classId &&
            this.availableRaceNumbers.filter(number => number == this.activePastInfo.number).length == 1)
          {
            this.editedItem.raceNumber = this.activePastInfo.number;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
.partbg {
  background: rgba(197, 220, 218, 0.64) !important;
}
button.mb-2.center-on-responsive.btn-class.v-btn.v-btn--disabled.v-btn--has-bg.theme--dark.v-size--default {
  background-color: rgba(0, 0, 0, .12) !important;
  color: white !important;
}
</style>

<style scoped>
.v-data-table header {
  background: rgba(197, 220, 218, 0.64) !important;
  color: black !important;
}

.livelaps-id {
  color: #484848 !important;
  font-size: small !important;
}

@media (max-width: 1024px) {
  .center-on-responsive {
    margin: 0 auto !important;
  }
}
@media (min-width: 1025px) {
  .hide-after-responsive {
    display: none !important;
  }
}
</style>
